import { useContext } from 'react'

import { PaymentPortalContext } from '../../providers/PaymentPortalProvider/PaymentPortalProvider'
import { RepairPaymentEntry } from '../../sdk'

const useExistingPayment: () => RepairPaymentEntry | undefined = () => {
  const { apiKey, payments } = useContext(PaymentPortalContext)
  return payments && payments.find((payment) => payment.info!.apiKey === apiKey)
}

export default useExistingPayment
